export const getTeam = (teamId, homeTeam, awayTeam) => {
    if (homeTeam.id === teamId) {
        return homeTeam;
    }
    if (awayTeam.id === teamId) {
        return awayTeam;
    }
};
//# sourceMappingURL=getTeam.js.map